module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2p1",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Contents#rpt1"
    }
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Contents#rpt1"
    }
  }, [_c('span', {
    staticClass: "greyf"
  }, [_vm._v("OLDER")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Contents#rpt1"
    }
  }, [_vm._v("SLOWER")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Contents#rpt1"
    }
  }, [_c('span', {
    staticClass: "greyf"
  }, [_vm._v("FATTER?")])])]), _vm._v(" "), _c('p', {
    staticClass: "normalp"
  }, [_vm._v("We’ve been told that as we age, we can expect a rapid decline in physical attributes, especially those that determine performance in endurance sports. There are many questions we athletes typically have about this topic: Are the changes inevitable? How rapidly can we expect the changes to occur? What is the cause of the changes? Can we do anything to slow or stop the decline? Is it possible to reverse the changes? You’ve probably pondered some of these as you’ve gotten older. In "), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("Chapters 1")]), _vm._v(" through "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(", we will seek the answers."), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e05d69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Part01.vue
// module id = 81
// module chunks = 0